module.exports = __webpack_public_path__ + "53436aca8627a49f4deaaa44dc9e3c05.woff2";